// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  WORKER_CONFIG_MAKE_DEFAULT_COST_DEFINITION,
} from './constants';

export function makeDefaultCostDefinition() {
  return {
    type: WORKER_CONFIG_MAKE_DEFAULT_COST_DEFINITION,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case WORKER_CONFIG_MAKE_DEFAULT_COST_DEFINITION:
      return {
        ...state,
        genericWorkerCostDefinitions: [
          {"orConditions":[{"dates":[],"roleCombinations":[["WL"]],"locations":["KA","KR"]}],"costByNumPlans":[100,0,2147483647],"displayName":"SampleCost"}
        ],
        numChanges: state.numChanges ? state.numChanges + 1 : 1,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/worker-config/redux/makeDefaultCostDefinition.js